import { Button } from "primereact/button";
import { useEffect, useMemo, useRef, useState, isValidElement } from "react";
import { createPortal } from "react-dom";
import "../../styles/components/display.scss";

import { MapMarker } from "./Marker";

const CenterMapButton = ({markers, childrenCommon}) => {
    const { gmap } = childrenCommon;
    const newBounds = useMemo(() => {
        let bounds = new globalThis.google.maps.LatLngBounds();
        if (gmap) {
            for (let i = 0; i < markers.length; i++) {
                if ((markers[i].latitud !== null) && (markers[i].longitud !== null)) {
                    let markerPosition = new globalThis.google.maps.LatLng(markers[i].latitud, markers[i].longitud);
                    bounds.extend(markerPosition);
                }
                /* if ((markers[i].latitud === 0) && (markers[i].longitud === 0)) {
                    console.log(!Number.isFinite(markers[i].latitud));
                    console.log(!Number.isFinite(markers[i].longitud));
                } */
            }
        }
        return bounds;
    },[markers, gmap]);
    const resetInfo = useRef({ mustReset: true });

    useEffect(() => {
        resetInfo.current.mustReset = true;
    }, [childrenCommon]);

    useEffect(() => {
        const { bounds, gmap: map } = childrenCommon || {};
        const currentCenter = map?.getCenter?.();
        const currentLat = currentCenter?.lat?.();
        const currentLng = currentCenter?.lng?.();

        const boundsCenter = !bounds.isEmpty() && bounds.getCenter();
        const bLat = boundsCenter?.lat?.();
        const bLng = boundsCenter?.lng?.();

        if (Number.isFinite(currentLat) && Number.isFinite(currentLng)) {
            if (resetInfo.current.mustReset && Number.isFinite(bLat) && Number.isFinite(bLng)) {
                if (bLat === currentLat && bLng === currentLng) return;
            } else {
                return; // just set the center if its invalid
            }
        }

        if (boundsCenter) {
            resetInfo.current.mustReset = false;
            map.setCenter(newBounds.getCenter());
            map.fitBounds(newBounds);
        }
    });
    const centerMap = () => {
        if (gmap) {
            gmap.setCenter(newBounds.getCenter());
            gmap.fitBounds(newBounds);
        }
    };
    return (
        <Button onClick={centerMap} className="centerMap">
            Center Map
        </Button>
    );
};

export default function GoogleMapsComponent({ divId, divRef, idKey, getInfoWindow, markers, hidden }) {
    const [gmap, setGmap] = useState(null);

    const childrenCommon = useMemo(() => {
        if (!gmap) return null;
        return { gmap, bounds: new globalThis.google.maps.LatLngBounds() };
    }, [gmap]);

    useEffect(() => {
        if (!globalThis.google) throw new Error("[google-maps-farm]: Google script not loaded");
        if (!globalThis.google.maps) throw new Error("[google-maps-farm]: Google maps script not loaded");
        const mapDiv = globalThis.document.getElementById(divId);
        if (!mapDiv) throw new Error("[google-maps-farm]: No Google Maps div");

        const gmap = new globalThis.google.maps.Map(mapDiv, {
            //center: newCenters,
            center: { lat: 0, lng: 0 },
            zoom: 3,
            mapTypeControl: true,
            streetViewControl:true,
            fullscreenControl: true,
            tilt: 0,
            rotateControl: false,
            keyboardShortcuts: false,
        });
        const panorama = gmap.getStreetView();
        panorama.setOptions({
            motionTracking: false,
            motionTrackingControl: false
        });
        if (globalThis.navigator.geolocation) {
            globalThis.navigator.geolocation.getCurrentPosition(
                (position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };

                    new globalThis.google.maps.Marker({
                        position: pos,
                        map: gmap,
                    });
                }
            );
        }

        setGmap(gmap);
    }, [divId]);

    return (
        <div id={divId} className={hidden ? "" : "mapHeight w-full"} ref={divRef}>
            {childrenCommon && markers ? markers.map((marker) => (
                ((marker.latitud !== null) && (marker.longitud !== null)) ? (
                    <MapMarker
                        key={marker[idKey]}
                        data={marker}
                        childrenCommon={childrenCommon}
                        getContent={getInfoWindow}
                    />
                ) : null
            )) : null}

            {childrenCommon ?
                <>
                    <MapControl
                        control={{ type: "TOP", element: <CenterMapButton markers={markers} childrenCommon={childrenCommon} />}}
                        childrenCommon={childrenCommon}
                    />
                </> : null}
        </div>
    );
}

// element can be a DOM element, or a React Component
const MapControl = ({ control, childrenCommon }) => {
    const map = childrenCommon?.gmap;
    const { type, element } = control || {};

    // used only when control is a React Component
    const el = useRef(false);
    if (isValidElement(element)) {
        if (!el.current) el.current = globalThis.document.createElement("div");
    } else if (el.current) el.current = false;

    const el_to_push = el.current || element;
    useEffect(() => {
        const controlPosition = globalThis.google.maps.ControlPosition[type];
        if (!controlPosition || !map?.controls) return;

        map.controls[controlPosition].push(el_to_push);
        return () => {
            const idx = map?.controls?.[controlPosition]?.indexOf(el_to_push);
            map?.controls?.[controlPosition]?.removeAt(idx);
        };
    }, [map, type, el_to_push]);

    if (el.current) {
        return createPortal(element, el.current);
    } else return null;
};
